interface Props {
    className: string;
    onClick?: () => void;
    title?: string
}
export default function emfCollapseIcon({ className, onClick, title }: Props) {
    return (
       
      <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" fill="currentColor" className={className} width="12.864" height="12.865" viewBox="0 0 12.864 12.865">
        <title>{title}</title>
        <g id="Group_193788" data-name="Group 193788" transform="translate(-1813.293 -523.293)">
          <g id="Group_193787" data-name="Group 193787" transform="translate(1820.996 524)">
            <path id="Path_29412" data-name="Path 29412" d="M10.131,4.783l-3.778.025L6.369,1.03" transform="translate(-6.354 -0.354)" fill="none" stroke="currentColor" strokeWidth="1" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
            <line id="Line_2653" data-name="Line 2653" y1="4.454" x2="4.453" transform="translate(0 0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          </g>
          <g id="Group_193786" data-name="Group 193786" transform="translate(1814 530.996)">
            <g id="Group_194217" data-name="Group 194217">
              <path id="Path_29413" data-name="Path 29413" d="M1.03,6.378l3.778-.025-.015,3.778" transform="translate(-0.354 -6.353)" fill="none" stroke="#585858" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
              <line id="Line_2654" data-name="Line 2654" x1="4.453" y2="4.454" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
            </g>
          </g>
        </g>
      </svg>

    )
}